import Vue from 'vue';
import RequiredLabel from '@/components/RequireLabel';
import SingleImageUploader from '@/components/SingleImageUploader';
import InputLabel from '@/components/InputLabel';
import OptionalLabel from "@/components/OptionalLabel";
import InfoDialog from "@/components/InfoDialog";
import SwitchButton from "@/components/SwitchButton";
import DeleteDialog from "@/components/DeleteDialog";
import Note from "@/components/Note";
import BookingCalendar from "./BookingCalendar";

Vue.component("RequiredLabel", RequiredLabel);
Vue.component("OptionalLabel", OptionalLabel);
Vue.component("SingleImageUploader", SingleImageUploader);
Vue.component("InputLabel", InputLabel);
Vue.component("DeleteDialog", DeleteDialog);
Vue.component("InfoDialog", InfoDialog);
Vue.component("SwitchButton", SwitchButton);
Vue.component("Note", Note);
Vue.component("BookingCalendar", BookingCalendar);
